/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-03T09:53:25.228
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentRepairWorkOrderDetails,
	listRentRepairWorkOrderDetailsInit,
	listRentRepairWorkOrderDetailsByAuthorizations,
	deleteRentRepairWorkOrderDetails
} from '@api/rentmanage/RentRepairWorkOrderDetails';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentRepairWorkOrderDetails({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairWorkOrderDetails(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairWorkOrderDetailsByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairWorkOrderDetailsByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairWorkOrderDetailsInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairWorkOrderDetailsInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentRepairWorkOrderDetails({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentRepairWorkOrderDetails({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
